import { createContext } from "react";

export const MfctContext = createContext(null)  